import { useContext } from "react";
import { CreateActionContext } from "./CreateActionContext";

function useInitialize() {
  const { setElement, setSelectedLang, setBackendFormErrors } = useContext(CreateActionContext);
  return (formDefaultValues: any) => {
    setBackendFormErrors({});
    setSelectedLang("es");
    setElement(formDefaultValues);
  };
}

export default useInitialize;
